/**
 * 側面資産（pdf worker・cmaps・standard_fonts・wasm・iccs）の基準 URL 解決（NFR-DIST-01）。
 * 既定では自身のスクリプトの位置から解決するため、配布物を任意の場所に置ける。
 */

/** スクリプト読み込み時に自身の URL を捕捉する（実行後に currentScript は null になる）。 */
const SCRIPT_URL: string | undefined =
  typeof document === 'undefined'
    ? undefined
    : ((document.currentScript as HTMLScriptElement | null)?.src ?? undefined);

/**
 * 資産の URL を解決する。
 * @param path 資産の相対パス（例: 'cmaps/'）
 * @param base 明示指定の基準 URL（オプション assetBase）。空なら自身のスクリプト位置。
 */
export function assetUrl(path: string, base?: string): string {
  const origin = base || SCRIPT_URL;
  if (!origin) {
    throw new Error(
      '資産の基準 URL を決定できない（assetBase オプションで明示指定が必要）',
    );
  }
  return new URL(path, origin).href;
}
